// app/javascript/projects/components/SideBarButton.jsx

import React from 'react';
import {Link} from 'react-router-dom';
import { useProjectModal } from '../../contexts/ProjectModalContext';

function SideBarButton(props) {
  const { showProjectModal } = useProjectModal();
  
  if (!props.isOnUserPage) {
    return (
      <div
        style={props.linkStyle}
        className={props.className}
      >
        <Link to={props.to} style={{display: 'block', color: 'inherit', textDecoration: 'none'}}>
          {props.children}
        </Link>
      </div>
    );
  } else {
    return (
      <div
        onClick={showProjectModal}
        style={props.linkStyle}
        className={props.className}
      >
        {props.children}
      </div>
    );
  }
}

export default SideBarButton;